import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { MarkdownSize } from '@vtblife/react-markdown-types';
import { useContext } from 'react';
import { TypePage } from '@vtblife/block-kit-types';
import { BlockKitContext } from '../contexts/context';
import { reduceBreakpoints } from '../utils/reduce-breakpoints';
export function useMarkdownBreakpoints(_ref) {
  var breakpoints = _ref.breakpoints;
  var _a;
  var typePage = (_a = useContext(BlockKitContext)) === null || _a === void 0 ? void 0 : _a.typePage;
  if (typePage === TypePage.Sidebar) {
    return reduceBreakpoints(function (breakpoint) {
      return {
        colorVariant: breakpoints[breakpoint].backgroundColor,
        sizeVariant: MarkdownSize.PersonalAreaSmall,
        minimalHeadingStyleLevel: 5
      };
    });
  }
  return reduceBreakpoints(function (breakpoint) {
    var markdownSettings = {
      sizeVariant: MarkdownSize.Small,
      minimalHeadingStyleLevel: 4
    };
    if (breakpoints[breakpoint].layoutType === '6:6') {
      markdownSettings = {
        sizeVariant: MarkdownSize.Medium,
        minimalHeadingStyleLevel: 3
      };
    } else if (breakpoints[breakpoint].layoutType === '3:3:3:3') {
      markdownSettings = {
        sizeVariant: MarkdownSize.Small,
        minimalHeadingStyleLevel: 5
      };
    }
    return _objectSpread({
      colorVariant: breakpoints[breakpoint].backgroundColor
    }, markdownSettings);
  });
}